const plugin = {
    install: vue => {
        vue.directive('click-outside', {
            beforeMount(element, binding) {
                element.clickOutsideEvent = function (event) {
                    if (!(element === event.target || element.contains(event.target))) {
                        binding.value(event, element);
                    }
                };
                document.addEventListener('click', element.clickOutsideEvent);
            },
            unmounted(element) {
                document.removeEventListener('click', element.clickOutsideEvent);
            }
        });
    }
};

export default plugin;